import { Sequence, useVideoConfig } from "remotion";
import { Audio } from "@remotion/media";
import { getMediaSrc } from "../utils/media.ts";
import {
  CompositionTimings,
  getVoiceOverStartFrame,
  msToFrames,
} from "../utils/timing.ts";
import { CompositionDto, VoiceOverDto } from "@repo/api/editor";
import { Captions } from "./Captions/Captions.tsx";

type Props = {
  timings: CompositionTimings;
  compositionVoiceOver: CompositionDto["voiceOver"];
  compositionCaptions: CompositionDto["captions"];
  voiceOvers: VoiceOverDto[];
  aspectRatio: CompositionDto["aspectRatio"];
};

export default function VoiceOver({
  timings,
  compositionVoiceOver,
  compositionCaptions,
  voiceOvers,
  aspectRatio,
}: Props) {
  const { fps } = useVideoConfig();

  if (!compositionVoiceOver) return null;

  const voiceOver = voiceOvers.find(
    (voiceOver) => voiceOver.externalId === compositionVoiceOver.externalId,
  )!;

  const startFrame = getVoiceOverStartFrame(timings, compositionVoiceOver, fps);

  return (
    <Sequence
      from={startFrame}
      style={{ pointerEvents: "none" }}
      premountFor={msToFrames(2000, fps)}
    >
      <Audio
        src={getMediaSrc(voiceOver.src)}
        pauseWhenBuffering={true}
        volume={compositionVoiceOver.volume ?? 1}
        style={{ pointerEvents: "none" }}
      />
      <Captions
        text={voiceOver.script}
        characterStartTimes={voiceOver.characterStartTimes}
        compositionCaptions={compositionCaptions}
        aspectRatio={aspectRatio}
      />
    </Sequence>
  );
}
